import config from '../config/server-config';
import { API_CALL_SUCCESSFULL } from '../constants/NumberConstants';
import api from '../api';

function readStoredUserEmail() {
  if (typeof window === 'undefined' || !window.localStorage) return '';
  const raw = window.localStorage.getItem('userEmail');
  return typeof raw === 'string' ? raw.trim() : '';
}

export const GetCompanyPeerGroup = async () => {
  try {
    const response = await api.post(config.GetCompanyPeerGroup);
    if (response.status === API_CALL_SUCCESSFULL) {
      return response.data;
    }
  } catch (e) {
    return false;
  }
};
export const GetInvestorPeerGroup = async () => {
  try {
    const response = await api.post(config.GetInvestorPeerGroup);
    if (response.status === API_CALL_SUCCESSFULL) {
      return response.data;
    }
  } catch (e) {
    return false;
  }
};
export const GetPeerGroupsData = async () => {
  try {
    const response = await api.post(config.GetPeerGroupsData);
    if (response.status === API_CALL_SUCCESSFULL) {
      return response.data;
    }
  } catch (e) {
    return false;
  }
};

export const AddSelectionInvestorPeerGroup = async (inv_peergroup_id) => {
  try {
    const response = await api.post(config.AddSelectionInvestorPeerGroup, {
      inv_peergroup_id: inv_peergroup_id,
    });
    if (response.status === API_CALL_SUCCESSFULL) {
      return response.data;
    }
  } catch (e) {
    return false;
  }
};
export const AddSelectionCompanyPeerGroup = async (cmp_peergroup_id) => {
  try {
    const response = await api.post(config.AddSelectionCompanyPeerGroup, {
      cmp_peergroup_id: cmp_peergroup_id,
    });
    if (response.status === API_CALL_SUCCESSFULL) {
      return response.data;
    }
  } catch (e) {
    return false;
  }
};

export const ValidateOldPasswordHash = async (req) => {
  try {
    const response = await api.post(
      config.ValidateOldPasswordHash,
      {
        txt_oldpassword: req.txt_oldpassword,
        userEmail: readStoredUserEmail(),
      },
      {
        cancelToken: req.cancelToken,
      },
    );
    if (response.status === API_CALL_SUCCESSFULL) {
      return response.data;
    }
  } catch (e) {
    return false;
  }
};
/**
 * Change password via preferences API (server verifies current password and enforces policy on the new password).
 * Sends `userEmail` from localStorage (`userEmail` key) for dbo.getPHash lookup, same as login.
 * @param {{ password: string, txt_oldpassword: string }} params Plaintext new password and current password.
 * @returns {Promise<object | false | { changePasswordError: true, text: string, errors: string[] }>} Parsed success body; structured client-side error object on HTTP 400/403 from API; false on other failures.
 */
export const HandleChangePassword = async ({ password, txt_oldpassword }) => {
  try {
    const response = await api.post(config.HandleChangePassword, {
      password,
      txt_oldpassword,
      userEmail: readStoredUserEmail(),
    });
    if (response.status === API_CALL_SUCCESSFULL) {
      return response.data;
    }
  } catch (e) {
    const status = e.response?.status;
    const data = e.response?.data;
    if ((status === 400 || status === 403) && data && (data.text || data.errors)) {
      const text = data.text || (Array.isArray(data.errors) && data.errors.length ? data.errors[0] : 'Request failed');
      return { changePasswordError: true, text, errors: data.errors || [] };
    }
    return false;
  }
};

export const SavePreferencesV3 = async (res) => {
  try {
    // Validate input - don't save if array is empty or invalid
    if (!res || !Array.isArray(res) || res.length === 0) {
      return;
    }

    // Fetch current preferences first to preserve values not in the array
    let currentPreferences = {};
    try {
      const currentResponse = await api.post(config.GetPreferences);
      if (currentResponse.status === API_CALL_SUCCESSFULL) {
        currentPreferences = currentResponse.data || {};
      }
    } catch (e) {
      // If fetch fails, continue with defaults
      // Current preferences will remain empty object, defaults will be used
    }

    // Helper to safely get boolean value, preserving true values
    const getBooleanValue = (value, fallback = false) => {
      if (value === true || value === 1 || value === '1' || value === 'true') return true;
      if (value === false || value === 0 || value === '0' || value === 'false') return false;
      return fallback;
    };

    // Start with current preferences (or defaults if fetch failed)
    const myJson = {
      Email1MonthlyNewsLetter: getBooleanValue(currentPreferences.Email1MonthlyNewsletter, false),
      Email2EmailUpdates: getBooleanValue(currentPreferences.Email2EmailUpdates, false),
      Email33rdParty: getBooleanValue(currentPreferences.Email33rdParty, false),
      DailyNewsletter: getBooleanValue(
        currentPreferences.DailyNewsletter ?? currentPreferences.daily_newsletter,
        false,
      ),
      NAEmailUpdates: getBooleanValue(currentPreferences.NAEmailUpdates, false),
      AAEmailUpdates: getBooleanValue(currentPreferences.AAEmailUpdates, false),
      AISWeeklyNewsletter: getBooleanValue(
        currentPreferences.AISWeeklyNewsletter ?? currentPreferences.ais_weekly_newsletter,
        false,
      ),
    };

    // Update with values from the array
    res.map((item) => {
      if (item.children !== undefined && item.children.length > 0) {
        item.children.map((itemChildren) => {
          if (itemChildren.id === 'NAEmailUpdates') {
            myJson[itemChildren.id] = itemChildren.checked;
            return myJson[itemChildren.id];
          }
          if (itemChildren.id === 'AAEmailUpdates') {
            myJson[itemChildren.id] = itemChildren.checked;
            return myJson[itemChildren.id];
          }
          return '';
        });
      }
      if (item.id === 'Email1MonthlyNewsLetter') {
        myJson[item.id] = item.checked;
        return myJson[item.id];
      }
      if (item.id === 'Email2EmailUpdates') {
        myJson[item.id] = item.checked;
        return myJson[item.id];
      }
      if (item.id === 'Email33rdParty') {
        myJson[item.id] = item.checked;
        return myJson[item.id];
      }
      if (item.id === 'DailyNewsletter') {
        myJson.DailyNewsletter = item.checked;
        return myJson.DailyNewsletter;
      }
      if (item.id === 'AISWeeklyNewsletter') {
        myJson.AISWeeklyNewsletter = item.checked;
        return myJson.AISWeeklyNewsletter;
      }
      return '';
    });

    const response = await api.post(config.SavePreferencesV3, {
      Email1MonthlyNewsLetter: myJson.Email1MonthlyNewsLetter,
      Email2EmailUpdates: myJson.Email2EmailUpdates,
      Email33rdParty: myJson.Email33rdParty,
      NAEmailUpdates: myJson.NAEmailUpdates,
      AAEmailUpdates: myJson.AAEmailUpdates,
      DailyNewsletter: myJson.DailyNewsletter,
      AISWeeklyNewsletter: myJson.AISWeeklyNewsletter,
    });
    if (response.status === API_CALL_SUCCESSFULL) {
      return response.data;
    }
  } catch (e) {
    return false;
  }
};
